import { request, post } from '@/plugins/request';
export function detailEtp(data) {
    return post('/guarantee/v0.1/guarantee/user/tc/detailCByUserId', data);
}